import React from 'react';
import PropTypes from 'prop-types';
import { roundPrice } from 'lib/pricing_utils';
import { capitalize } from 'lib/string_utils';
import { t } from 'services/translation';

export default class UnitPrice extends React.Component {
  static displayName = 'UnitPrice';
  static propTypes = {
    unit: PropTypes.object.isRequired,
  };

  render() {
    const { unit } = this.props;
    const label = unit.count > 1 ? t(unit.noun_plural) : t(unit.noun_singular);
    const separator = unit.per_tour ? ` ${t('FOR')} ` : ' x ';
    return (
      <div className="unitPrice">
        {roundPrice(unit.unit_price_formatted)}
        {separator}
        {unit.count} {capitalize(label)}
      </div>
    );
  }
}
